import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=015e6ddc"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('015e6ddc')) {
      api.createRecord('015e6ddc', component.options)
    } else {
      api.reload('015e6ddc', component.options)
    }
    module.hot.accept("./Carousel.vue?vue&type=template&id=015e6ddc", function () {
      api.rerender('015e6ddc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/core/guest/Carousel.vue"
export default component.exports